import Icon from "./Icon";

export const PageHeader = ({ title, sub }) => (
  <div style={{ background: "#f5f7fa", borderBottom: "1px solid #e8eaf0", padding: "13px 20px" }}>
    <span style={{ fontWeight: 600, color: "#1565c0", fontSize: 15 }}>{title}</span>
    {sub && <span style={{ color: "#90a4ae", fontSize: 12, marginLeft: 10 }}>{sub}</span>}
  </div>
);

export const Card = ({ children, style = {} }) => (
  <div style={{ background: "#fff", borderRadius: 12, boxShadow: "0 2px 12px rgba(0,0,0,0.06)", overflow: "hidden", ...style }}>
    {children}
  </div>
);

export const Btn = ({ children, color = "#1565c0", bg, onClick, style = {}, disabled = false }) => {
  const bgColor = bg || color;
  return (
    <button onClick={onClick} disabled={disabled} style={{
      padding: "9px 22px", background: disabled ? "#b0bec5" : bgColor, color: "#fff", border: "none",
      borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: disabled ? "not-allowed" : "pointer",
      display: "inline-flex", alignItems: "center", gap: 6, ...style
    }}>{children}</button>
  );
};

export const Input = ({ label, placeholder, defaultValue, value, onChange, type = "text", style = {} }) => (
  <div style={style}>
    {label && <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#78909c", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.4px" }}>{label}</label>}
    <input type={type} placeholder={placeholder} defaultValue={defaultValue} value={value} onChange={onChange}
      style={{ width: "100%", padding: "9px 12px", border: "1.5px solid #e0e0e0", borderRadius: 8, fontSize: 13, boxSizing: "border-box", outline: "none", color: "#263238" }} />
  </div>
);

export const Select = ({ label, options = [], value, onChange, style = {} }) => (
  <div style={style}>
    {label && <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#78909c", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.4px" }}>{label}</label>}
    <select value={value} onChange={onChange} style={{ width: "100%", padding: "9px 12px", border: "1.5px solid #e0e0e0", borderRadius: 8, fontSize: 13, boxSizing: "border-box", outline: "none", color: "#263238", background: "#fff" }}>
      {options.map(o => <option key={o}>{o}</option>)}
    </select>
  </div>
);

export const Table = ({ columns, rows, renderRow, empty = "No data" }) => (
  <div style={{ overflowX: "auto" }}>
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
      <thead>
        <tr style={{ background: "#f5f7fa" }}>
          {columns.map(c => (
            <th key={c} style={{ padding: "11px 14px", textAlign: "left", color: "#455a64", fontWeight: 700, borderBottom: "2px solid #e8eaf0", whiteSpace: "nowrap", fontSize: 12 }}>{c}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.length === 0
          ? <tr><td colSpan={columns.length} style={{ padding: 32, textAlign: "center", color: "#90a4ae" }}>{empty}</td></tr>
          : rows.map((row, i) => (
            <tr key={i} style={{ borderBottom: "1px solid #f0f0f0" }}
              onMouseEnter={e => e.currentTarget.style.background = "#f8f9ff"}
              onMouseLeave={e => e.currentTarget.style.background = ""}>
              {renderRow(row, i)}
            </tr>
          ))}
      </tbody>
    </table>
  </div>
);

export const Modal = ({ title, onClose, children, width = 600 }) => (
  <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <div style={{ background: "#fff", borderRadius: 12, width, maxWidth: "92vw", maxHeight: "88vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px", borderBottom: "1px solid #e8eaf0" }}>
        <span style={{ fontWeight: 700, fontSize: 15, color: "#1a2744" }}>{title}</span>
        <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#607d8b" }}><Icon name="x" size={20} /></button>
      </div>
      <div style={{ padding: 24 }}>{children}</div>
    </div>
  </div>
);

export const StatusBadge = ({ status }) => {
  const colors = { New: "#1565c0", InProgress: "#f57c00", Closed: "#0f9d58", Active: "#0f9d58", Deactive: "#d32f2f", Inactive: "#d32f2f", Pending: "#f57c00" };
  const bgs = { New: "#e3f2fd", InProgress: "#fff3e0", Closed: "#e6f4ea", Active: "#e6f4ea", Deactive: "#fce8e6", Inactive: "#fce8e6", Pending: "#fff3e0" };
  return (
    <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600, color: colors[status] || "#607d8b", background: bgs[status] || "#f5f5f5" }}>{status}</span>
  );
};
